import React from "react";
import { VisitorsMappingContextProvider } from "./VisitorsMappingView";
import VisitorsMapping from "./view/VisitorsMapping";
import VisitorsContent from "../../constants/contentFile.json";

const VisitorsMappingPage = () => {
  return (
    <VisitorsMappingContextProvider>
      <VisitorsMapping textContent={VisitorsContent.visitorMapping} />
    </VisitorsMappingContextProvider>
  );
};
export default VisitorsMappingPage;
